import {
  Box,
  BoxProps,
  Card,
  LinearProgress,
  Stack,
  StackProps
} from "@mui/material";
import { linearProgressClasses } from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { StatusBoxes } from "./StatusBoxes.component";


export const CarouselCard = styled(Card)(({ theme }) => {
  return {
    border: `2px solid ${theme.customColors.border}`,
    borderRadius: "1rem",
    height: "18.5rem",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "23.5rem",
    maxWidth: "100%",
    boxSizing: "border-box",
    transition: "all 0.35s ease",
    "& .collapse_cta": { opacity: 0, height: "0", transition: "all 0.35s ease" },
    [theme.breakpoints.up("sm")]: {
      "&:hover": {
        "& .lo_tag_list": {
          transition: "all 0.35s ease",
          opacity: 1,
          height: "unset",
          marginBottom: "0.75rem"
        },
        "& .box_collapse": { 
          height: "unset" 
        },
        "& .collapse_cta": { 
          opacity: 1,
          height: "3.5rem",
          transition: "all 0.35s ease"
        },
        background: theme?.customColors?.backgroundCard,
        border: `2px solid ${theme.customColors.borderAccent}`,
        transition: "all 0.35s ease"
      },

      "&:focus-within": { 
        "& .lo_tag_list": {
          transition: "all 0.35s ease",
          opacity: 1,
          height: "unset",
          marginBottom: "0.75rem"
        },
        "& .box_collapse": {  minHeight: "fit-content" },
        "& .collapse_cta": { opacity: 1, height: "3.5rem", transition: "all 0.35s ease" },
        background: theme?.customColors?.backgroundCard,
        border: `2px solid ${theme.customColors.borderAccent}`,
        transition: "all 0.35s ease"
      }
    },
    [theme.breakpoints.down("sm")]: {
      width: "-webkit-fill-available",
      "& .box_collapse": { minHeight: "fit-content" },
      "& .collapse_cta": { opacity: 1, minHeight: "fit-content", transition: "all 0.35s ease", paddingBottom:"1rem"  },
      "& .lo_tag_list": {
        transition: "all 0.35s ease",
        opacity: 1,
        height: "unset",
        marginBottom: "0.75rem"
      }
    }
  };
});

export const StyledCoverVideo = styled(Box)<
  BoxProps & { $image?: string }
>(({ $image }) => ({
  "&:before": {
    content: "''",
    display: "flex",
    height: "100%",
    // inset: 0,
    position: "absolute",
    width: "100%",
    zIndex: 1
  },
  aspectRatio: "16/9",
  backgroundImage: $image
    ? `url(${$image})`
    : undefined,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  // backgroundSize: "cover",
  height: "100%",
  objectFit: "cover",
  overflow: "hidden",
  position: "absolute",
  transition: "all 0.35s ease",
  "video": {
    height: "100%",
    width: "100%",
    objectFit: "cover"
  },
  width: "-webkit-fill-available",
  zIndex: 0
}));

export const CarouselInfo = styled(Stack)<StackProps>(({ theme }) => ({
  // height: "18.5rem",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  padding: "1rem 1rem 0rem",
  color: theme.customColors.exploreCardText,
  overflow: "hidden",
  background: theme?.customColors?.backgroundCard ?? "#232323",
  zIndex: 4,
  transition: "all 0.35s ease",
  [theme.breakpoints.down("sm")]: {
    margin: "0 auto"
  }
}));

export const CarouselMask = styled(Stack)(({ theme }) => ({
  background: `linear-gradient(180deg,rgba(${theme.customColors.gradient05Start}) 0%, rgba(${theme.customColors.gradient05End}) 100%)`,
  height: "100%",
  position: "absolute",
  transition: "all 0.35s ease",
  width: "23.5rem",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    margin: "0 auto"
  },
  zIndex: 3
}));

export const StatusBoxesContainer = styled(StatusBoxes)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto"
  }
}));
export const InfoContainer = styled(Stack)(() => ({
  zIndex: 5
}));

export const LinearProgressCustom = styled(LinearProgress)(({ theme }) => ({
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.customColors.border,
    borderRadius: "0.25rem",
    height: "0.1875rem"
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: "0.25rem",
    height: "0.1875rem",
    backgroundColor: theme.customColors.systemPrimary01Alternative02
  }
}));


export const CardTypeStyle = styled(Stack)<StackProps>(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row"

}));
export const LoTagListStyle = styled(Stack)<StackProps>(() => ({
  display: "flex",
  flexDirection: "row",
  opacity: 0,
  height: 0
}));

export const CompletitionStatus = styled("div")(() => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "space-between",
  marginTop: "0.75rem"
}));

export const HiddenCTAStyle = styled(Stack)<StackProps>(() => ({
  opacity: 0,
  transition: "all 0.35s ease",
  gap: "1rem"
}));
export const BoxCollapse = styled(Box)<StackProps>(() => ({
  flexDirection: "column",
  position: "relative",
  transition: "all 0.35s ease",
  minHeight: 0
}));

export const StyledDurationBadge = styled(Box)<
  BoxProps & { $completed: boolean, $absolute?: boolean }
>(({ $completed, theme }) => ({
  alignItems: "center",
  background: $completed ? "#757575" : "#000",
  borderRadius: "0.25rem",
  color: "#FFF",
  boxSizing: "border-box",
  display: "flex",
  fontSize: "0.76875rem",
  fontWeight: 400,
  gap: "0.25rem",
  padding: "0.10938rem 0.4375rem",
  height: "1.5rem",
  pointerEvents: "none",
  "svg path": {
    fill: theme.customColors.textTag
  },
  "& > span": {
    lineHeight: "1.09375rem"
  }
}));

export const StatusBoxesStyle = styled("div")(() => ({
  display: "flex",
  flexWrap: "wrap",
  zIndex: 6,
  gap: "0.5rem",
  position: "absolute",
  top: "1rem",
  left: "1rem"
}));


